function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useMount, useSearchParam } from 'react-use';
import Page from '../../components/page/Page';
import { getUserProfile } from '../../redux/actions';
import routes from '../../routes/constants';
import text from '../../text';
import CompanyForm from '../dashboard/components/CompanyForm';
import UserAvatar from './UserAvatar';
import UserForm from './UserForm';
import Tabs, { Tab } from '../../components/containers/Tabs';
import MembershipTab from './MembershipTab';
import Button from '../../components/button/Button';
import { isUserGovernment, isUserStaff } from '../../utilities/user';
import ReferralBar from './ReferralBar';
var UserProfile = function() {
    var dispatch = useDispatch();
    var history = useHistory();
    var location = useLocation();
    var userProfile = useSelector(function(state) {
        return state.profileReducer;
    }).userProfile;
    var focusedTab = useSearchParam('focusedTab') || 'profile';
    useMount(function() {
        dispatch(getUserProfile());
    });
    var handleTabSelect = function(tabKey) {
        if (tabKey === 'profile') {
            history.replace({
                pathname: location.pathname,
                search: ''
            });
        }
    };
    var tabs = [
        {
            component: /*#__PURE__*/ React.createElement("div", {
                className: "d-flex"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "left-section"
            }, /*#__PURE__*/ React.createElement(UserForm, null), /*#__PURE__*/ React.createElement(CompanyForm, null)), /*#__PURE__*/ React.createElement("div", {
                className: "right-section"
            }, /*#__PURE__*/ React.createElement(UserAvatar, {
                profileImage: userProfile.profile_image,
                avatarIcon: "v1"
            }))),
            title: text('profile'),
            eventKey: 'profile'
        }
    ].concat(_to_consumable_array(!isUserStaff(userProfile) && !isUserGovernment(userProfile) ? [
        {
            component: /*#__PURE__*/ React.createElement(MembershipTab, null),
            title: text('membership'),
            eventKey: 'membership'
        }
    ] : []));
    return /*#__PURE__*/ React.createElement(Page, {
        id: "UserProfile",
        title: text('account')
    }, /*#__PURE__*/ React.createElement(ReferralBar, null), /*#__PURE__*/ React.createElement(Page.Top, null, /*#__PURE__*/ React.createElement("h2", null, text('account')), /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        icon: "plus",
        onClick: function() {
            return history.push(routes.mp.root);
        }
    }, text('newProject')), /*#__PURE__*/ React.createElement(UserAvatar, {
        className: "my-2",
        profileImage: userProfile.profile_image,
        avatarIcon: "v1"
    })), /*#__PURE__*/ React.createElement(Tabs, {
        defaultActiveKey: focusedTab,
        onSelect: handleTabSelect
    }, tabs.map(function(param, index) {
        var component = param.component, title = param.title, eventKey = param.eventKey;
        return /*#__PURE__*/ React.createElement(Tab, {
            key: index,
            title: title,
            eventKey: eventKey
        }, component);
    })));
};
export default UserProfile;
